import React, { useState, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  MarkerClusterer,
  Marker,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
//import mapicon from "../../../../assets/img/Basic_red_dot.png";

export default function SimpleMap(props: any) {
  const { setMapPopupInput, mapData, setMapData } = props;
  const [map, setMap] = useState<any>(null);
  const [addressGeocode, setaddressGeocode] = useState<any>({
    center: "",
  });
  const setHeight = props.height;

  /**to set height */
  const setMapContainerHeight: any = setHeight ? "94vh" : "300px";
  const mapContainerStyle: any = {
    height: setMapContainerHeight,
    width: "100%",
  };

  /**to default center point */
  // -95.641780
  let center: any = { lat: mapData.lati, lng: mapData.lon };
  
  const onLoad = React.useCallback(function callback(map: any) {
    map.setZoom(17);
    setMap(map);
  }, []);
  const onUnmount = React.useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  const getLatLong = (e: any) => {
    setMapData({
      lati: e.latLng.lat(),
      lon: e.latLng.lng(),
    });
    setMapPopupInput(
      `${e.latLng.lat().toFixed(6)},${e.latLng.lng().toFixed(6)}`
    );
    map.setZoom(17);
    setMap(map);
  };

  return (
    // Important! Always set the container height explicitly
    <LoadScript googleMapsApiKey="AIzaSyCdsXnMXcV_vTCPjTd5tHGCi2Oed3hVKEQ">
      <div className="popupMap-wrapper">
        <GoogleMap
          onLoad={onLoad}
          onUnmount={onUnmount}
          center={center}
          //zoom={zoom}
          mapContainerStyle={mapContainerStyle}
          mapTypeId="satellite"
          onClick={(e: any) => getLatLong(e)}
          // tilt={45}
        >
          <MarkerClusterer maxZoom={15}>
            {(clusterer) => (
              <Marker
                position={{ lat: mapData.lati, lng: mapData.lon }}
                clusterer={clusterer}
                title={props?.data?.title}
                // icon={displayHeliCopIcon}
              ></Marker>
            )}
          </MarkerClusterer>
        </GoogleMap>
      </div>
    </LoadScript>
  );
}
